import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { AlertDialogData } from './alert-dialog-data.model';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  imports: [MatDialogTitle, MatIcon, CdkScrollable, MatDialogContent, MatDialogActions, MatButton],
})
export class AlertDialogComponent {
  dialogRef = inject<MatDialogRef<AlertDialogComponent>>(MatDialogRef);
  data = inject<AlertDialogData>(MAT_DIALOG_DATA);

  private static iconMapping = {
    error: 'error',
    success: 'check_circle',
    warning: 'warning',
    info: 'info',
  };

  public fontIcon: string;

  constructor() {
    const data = this.data;

    this.fontIcon = AlertDialogComponent.iconMapping[data.messageType];
  }

  close(): void {
    this.dialogRef.close();
  }

  onButtonClick(button: { action: (dialog) => void }) {
    button.action(this);
  }

  getButtonId(label: string) {
    return 'app-alert-dialog-' + label.toLowerCase().replace(/\s/g, '');
  }
}
